import React, { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import AnalyticsContext from "./analyticsContext";

function ChartModeSwitch() {
  const intl = useIntl();
  const { isStacked, setIsStacked } = useContext(AnalyticsContext);

  const options = [
    {
      label: intl.formatMessage({
        id: "report.graph",
        defaultMessage: "Graph",
      }),
      value: false,
    },
    {
      label: intl.formatMessage({
        id: "report.stacked",
        defaultMessage: "Stacked",
      }),
      value: true,
    },
  ];

  return (
    <div className="d-flex flex-column mb-xs-2">
      <span>
        <FormattedMessage id="report.view" defaultMessage="View" />
      </span>
      <Dropdown
        options={options}
        onChange={(item) => setIsStacked(item.value)}
        defaultValue={options.filter((item) => item.value === isStacked)[0].label}
      />
    </div>
  );
}

export default ChartModeSwitch;
